import { useState, useEffect, useRef } from "react";
import Header from "../../components/Navbar";
import Loader from "../../components/Loader/loader";
import "./buyer.css";
import placeimg from "../../myimgs/Group 193.png";
import { useNavigate } from "react-router-dom";
import { FaListUl, FaMapMarkedAlt } from "react-icons/fa";
import { LoadScriptNext } from "@react-google-maps/api";
import Nearloaction from "../../myimgs/nearlocn.png";
import Swal from "sweetalert2";
import Noprop from "../../myimgs/NestingIndia.png";
import {
  propertyTypes,
  priceList,
  bedsList,
  bathsList,
  squareFootageList,
  buildingTypeList,
  storeysList,
  landSizeList,
  maintenanceFeeMonthlyList,
  propertyTaxYearlyList,
  yearBuiltList,
  farmList,
  parkingList,
  buildingStyleList,
  numberOfUnitsList,
  exteriorBuildingSizeList,
  zoningTypeList,
} from "../../data/states";
import resetimg from "../../myimgs/circular (1).png";

// map,...
// Google Maps components
const { GoogleMap, Marker, InfoWindow } = require("@react-google-maps/api");
// Map container style
const mapContainerStyle = {
  height: "436px",
  width: "100%",
  position: "relative",
  borderRadius: "10px",
  right: "0px",
};
const fullScreenMapContainerStyle = {
  height: "100vh",
  width: "100vw",
  position: "fixed",
};
const defaultCenter = {
  lat: 43.7,
  lng: -79.42,
};
// Custom marker icon
const customMarkerIcon = {
  url:
    "data:image/svg+xml;base64," +
    btoa(`
    <svg width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
      <path fill="#3367d6" stroke="#fff" stroke-width="2" d="M16 2c-5.523 0-10 4.477-10 10 0 7 10 16 10 16s10-9 10-16c0-5.523-4.477-10-10-10z"/>
      <circle fill="#fff" cx="16" cy="12" r="4"/>
    </svg>
  `),
  scaledSize: { width: 32, height: 32 },
  anchor: { x: 16, y: 32 },
};
// Cluster icon generator
const generateClusterIcon = (count) => {
  const size = 40 + Math.min(count / 5, 20); // Size increases with count
  const color = count > 10 ? "#d33636" : count > 5 ? "#d68c36" : "#3367d6";

  return {
    url:
      "data:image/svg+xml;base64," +
      btoa(`
      <svg width="${size}" height="${size}" viewBox="0 0 ${size} ${size}" xmlns="http://www.w3.org/2000/svg">
        <circle cx="${size / 2}" cy="${size / 2}" r="${
        size / 2 - 2
      }" fill="${color}" stroke="#fff" stroke-width="3"/>
        <text x="${size / 2}" y="${
        size / 2 + 4
      }" text-anchor="middle" fill="white" font-weight="bold" font-size="14" font-family="Arial, sans-serif">${count}</text>
      </svg>
    `),
    scaledSize: { width: size, height: size },
    anchor: { x: size / 2, y: size / 2 },
  };
};
const calculateClusters = (markers, zoom) => {
  const clusters = [];
  const clusteredIds = new Set();

  // Larger grid at lower zoom → more clustering
  const baseGridSize = 0.05; // adjust for density
  const gridSize = baseGridSize * Math.pow(2, (10 - zoom) / 1.5);

  markers.forEach((marker, index) => {
    if (clusteredIds.has(marker.propertyId)) return;

    const nearbyMarkers = markers.filter((otherMarker) => {
      if (clusteredIds.has(otherMarker.propertyId)) return false;

      const latDiff = Math.abs(marker.lat - otherMarker.lat);
      const lngDiff = Math.abs(marker.lng - otherMarker.lng);

      // Use gridSize directly (larger = more clustering)
      return latDiff < gridSize && lngDiff < gridSize;
    });

    if (nearbyMarkers.length === 1) {
      clusters.push({
        ...marker,
        isCluster: false,
        count: 1,
      });
    } else {
      const avgLat =
        nearbyMarkers.reduce((sum, m) => sum + m.lat, 0) / nearbyMarkers.length;
      const avgLng =
        nearbyMarkers.reduce((sum, m) => sum + m.lng, 0) / nearbyMarkers.length;

      clusters.push({
        lat: avgLat,
        lng: avgLng,
        isCluster: true,
        count: nearbyMarkers.length,
        markers: nearbyMarkers,
        propertyId: `cluster-${index}`,
        propertyName: `${nearbyMarkers.length} properties`,
      });

      nearbyMarkers.forEach((m) => clusteredIds.add(m.propertyId));
    }
  });

  return clusters;
};
// map,...

function Buyers() {
  const [mapOpen, setMapOpen] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [propertyType, setPropertyType] = useState("");
  const [minPrice, setMinPrice] = useState("");
  const [maxPrice, setMaxPrice] = useState("");
  const [mapCenter, setMapCenter] = useState(defaultCenter);
  const [mapZoom, setMapZoom] = useState(12);
  const [clusters, setClusters] = useState([]);
  const mapRef = useRef(null);
  const [appliedFilters, setAppliedFilters] = useState({});
  // State to track mode
  const [showNearby, setShowNearby] = useState(false);

  // Pagination states
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [pageSize] = useState(25);

  const navigate = useNavigate();

  const handleViewDetails = (id, propeId) => {
    // Open the route in a new tab with query params
    const url = `/propertyDetail?id=${id}&propeId=${propeId}`;
    window.open(url, "_blank");
  };

  // Helper function — get user location
  const getCurrentLocation = () => {
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const lat = position.coords.latitude;
            const lng = position.coords.longitude;
            console.log("User location fetched:", { lat, lng });
            resolve({ lat, lng });
          },
          (error) => {
            console.warn("Location denied or error:", error.message);
            reject(error);
          }
        );
      } else {
        reject(new Error("Geolocation not supported by this browser."));
      }
    });
  };
  // Helper function — get user location

  // Fetch properties with pagination and lat long
  const fetchProperties = async (
    page = 0,
    filters = {},
    userLocation = null
  ) => {
    try {
      setLoading(true);
      const baseUrl = process.env.REACT_APP_API_BASE_URL;
      const userId = localStorage.getItem("userId");

      const requestBody = {
        page,
        size: pageSize,
        currentUser: userId,
        sell: false,
        forBidinng: true,
        isApproved: true,
        ...filters,
      };

      const response = await fetch(`${baseUrl}/property/list`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestBody),
      });

      const data = await response.json();
      console.log(" Property API Response:", data);

      if (data?.data?.content?.length > 0) {
        const content = data.data.content;
        setProperties(content);
        setTotalPages(data.data.totalPages);
        setTotalElements(data.data.totalElements);

        if (userLocation) {
          setMapCenter({ lat: userLocation.lat, lng: userLocation.lng });
        } else if (content[0].latitude && content[0].longitude) {
          setMapCenter({
            lat: Number(content[0].latitude),
            lng: Number(content[0].longitude),
          });
        } else {
          setMapCenter({ lat: 28.6139, lng: 77.209 });
        }
      } else {
        setProperties([]);
        if (userLocation) {
          setMapCenter({ lat: userLocation.lat, lng: userLocation.lng });
        } else {
          setMapCenter({ lat: 28.6139, lng: 77.209 });
        }
      }
    } catch (error) {
      console.error("Error fetching properties:", error);
    } finally {
      setLoading(false);
    }
  };
  // Fetch properties with pagination and lat long

  // on Page Load
  useEffect(() => {
    const initFetch = async () => {
      try {
        const location = await getCurrentLocation();
        await fetchProperties(
          0,
          { latitude: location.lat, longitude: location.lng, radius: 10 },
          location
        );
        setShowNearby(true); // by default nearby mode on
      } catch (error) {
        await fetchProperties(0);
        setShowNearby(false); // fallback to all properties
      }
    };

    initFetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // on Page Load

  // Toggle Button Handler
  const handleToggleView = async () => {
    if (showNearby) {
      // Currently showing nearby → switch to all
      await fetchProperties(0);
      setShowNearby(false);
    } else {
      // Currently showing all → switch to nearby
      try {
        const location = await getCurrentLocation();
        await fetchProperties(
          0,
          { latitude: location.lat, longitude: location.lng, radius: 10 },
          location
        );
        setShowNearby(true);
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops!",
          text: "Location not allowed or unavailable.",
          confirmButtonColor: "#1E88E5",
        });
      }
    }
  };
  // Toggle Button Handler

  // Update clusters when properties or zoom changes
  useEffect(() => {
    console.log(
      "List IDs:",
      properties.map((p) => p.id)
    );
    console.log(
      "Map markers:",
      pagedMapLocations.map((m) => m.propertyId)
    );
    if (pagedMapLocations.length > 0) {
      const newClusters = calculateClusters(pagedMapLocations, mapZoom, null);
      setClusters(newClusters);
    }
  }, [properties, mapZoom]);
  // Update clusters when properties or zoom changes

  // filter propert get ...
  // Handle page change
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);

    // Build filters object
    const filters = {};
    if (searchQuery) filters.searchQuery = searchQuery;
    if (propertyType) filters.propertyType = propertyType;
    if (minPrice) filters.minPrice = minPrice;
    if (maxPrice) filters.maxPrice = maxPrice;

    fetchProperties(newPage, filters);
  };

  const fetchFilteredProperties = async (page = 0) => {
    try {
      setLoading(true);
      const baseUrl = process.env.REACT_APP_API_BASE_URL;
      const userId = localStorage.getItem("userId");

      const requestBody = {
        page: page,
        size: pageSize,
        currentUser: userId,
        sell: false,
        forBidinng: true,
        isApproved: true,
        //Filters
        searchQuery: searchQuery || null,
        propertyType: propertyTypex || propertyType || null,
        minPrice: minPrice || null,
        maxPrice: maxPrice || null,
        beds: beds || null,
        baths: baths || null,
        minSquareFootage: minSquareFootage || null,
        maxSquareFootage: maxSquareFootage || null,
        buildingType: buildingType || null,
        farmType: farmType || null,
        parkingType: parkingType || null,
        buildingStyle: buildingStyle || null,
        numberOfUnits: numberOfUnits || null,
        exteriorBuildingSize: exteriorBuildingSize || null,
        ownershipTitle: ownershipTitle || null,
        zoningType: zoningType || null,
        landSize: landSize || null,
      };

      const response = await fetch(`${baseUrl}/property/list`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      const data = await response.json();
      if (data?.data?.content) {
        setProperties(data.data.content);
        setTotalPages(data.data.totalPages);
        setTotalElements(data.data.totalElements);
        setCurrentPage(page);
      } else {
        setProperties([]);
        setTotalPages(0);
        setTotalElements(0);
      }
    } catch (error) {
      console.error("Error fetching filtered properties:", error);
    } finally {
      setLoading(false);
    }
  };
  // filters ..
  const [farmType, setFarmType] = useState("");
  const [parkingType, setParkingType] = useState("");
  const [buildingStyle, setBuildingStyle] = useState("");
  const [numberOfUnits, setNumberOfUnits] = useState("");
  const [exteriorBuildingSize, setExteriorBuildingSize] = useState("");
  const [propertyTypex, setPropertyTypex] = useState("");
  // Beds & Baths
  const [beds, setBeds] = useState("");
  const [baths, setBaths] = useState("");

  // Square Footage
  const [minSquareFootage, setMinSquareFootage] = useState("");
  const [maxSquareFootage, setMaxSquareFootage] = useState("");

  // Building Type
  const [buildingType, setBuildingType] = useState("");

  // Storeys
  const [minStoreys, setMinStoreys] = useState("");
  const [maxStoreys, setMaxStoreys] = useState("");

  // Ownership / Title
  const [ownershipTitle, setOwnershipTitle] = useState("");

  // Zoning Type
  const [zoningType, setZoningType] = useState("");
  const [landSize, setLandSize] = useState("");

  // Map locations for current page
  const pagedMapLocations = properties
    .map((prop) => {
      if (!prop || prop.latitude == null || prop.longitude == null) return null;

      const lat = Number(prop.latitude);
      const lng = Number(prop.longitude);

      if (
        isNaN(lat) ||
        isNaN(lng) ||
        lat < -90 ||
        lat > 90 ||
        lng < -180 ||
        lng > 180
      ) {
        return null;
      }

      return {
        lat: lat,
        lng: lng,
        propertyId: prop.id,
        propertyName: prop.propertyName,
        property: prop, // Include full property data
      };
    })
    .filter(Boolean);

  // Countdown component (unchanged)
  function Countdown({ start, end }) {
    const [timeLeft, setTimeLeft] = useState("");

    const formatDateTime = (dateString) => {
      const date = new Date(dateString);
      if (isNaN(date)) return "";
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      return `${day}-${month}-${year}, ${hours}:${minutes}`;
    };

    const getRemainingTime = (startTime, endTime) => {
      if (!startTime || !endTime) return "";

      const now = new Date();
      const startDate = new Date(startTime);
      const endDate = new Date(endTime);

      if (isNaN(startDate) || isNaN(endDate)) return "";

      // Before start
      if (now < startDate) {
        return (
          <>
            Starts In:
            <br />
            {formatDateTime(startDate)}
          </>
        );
      }

      const diff = endDate - now;
      if (diff <= 0) return "Ended";

      // When started, show Ends In
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((diff / (1000 * 60)) % 60);
      const seconds = Math.floor((diff / 1000) % 60);

      return (
        <>
          Ends In:
          <br />
          {`${days}D : ${hours}H : ${minutes}M : ${seconds}s`}
        </>
      );
    };

    useEffect(() => {
      const interval = setInterval(() => {
        setTimeLeft(getRemainingTime(start, end));
      }, 1000);

      return () => clearInterval(interval);
    }, [start, end]);

    return <h3>{timeLeft || ""}</h3>;
  }
  // Countdown component (unchanged)

  //  Generate pagination buttons
  const renderPaginationButtons = () => {
    const buttons = [];
    const maxVisiblePages = 5;

    let startPage = Math.max(0, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages - 1, startPage + maxVisiblePages - 1);

    // Adjust start page if we're near the end
    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(0, endPage - maxVisiblePages + 1);
    }

    // Previous button
    buttons.push(
      <button
        key="prev"
        disabled={currentPage === 0}
        onClick={() => handlePageChange(currentPage - 1)}
      >
        Prev
      </button>
    );

    // First page and ellipsis if needed
    if (startPage > 0) {
      buttons.push(
        <button
          key={0}
          className={currentPage === 0 ? "active" : ""}
          onClick={() => handlePageChange(0)}
        >
          1
        </button>
      );
      if (startPage > 1) {
        buttons.push(<span key="ellipsis1">...</span>);
      }
    }

    // Page numbers
    for (let i = startPage; i <= endPage; i++) {
      buttons.push(
        <button
          key={i}
          className={currentPage === i ? "active" : ""}
          onClick={() => handlePageChange(i)}
        >
          {i + 1}
        </button>
      );
    }

    // Last page and ellipsis if needed
    if (endPage < totalPages - 1) {
      if (endPage < totalPages - 2) {
        buttons.push(<span key="ellipsis2">...</span>);
      }
      buttons.push(
        <button
          key={totalPages - 1}
          className={currentPage === totalPages - 1 ? "active" : ""}
          onClick={() => handlePageChange(totalPages - 1)}
        >
          {totalPages}
        </button>
      );
    }

    // Next button
    buttons.push(
      <button
        key="next"
        disabled={currentPage === totalPages - 1}
        onClick={() => handlePageChange(currentPage + 1)}
      >
        Next
      </button>
    );

    return buttons;
  };
  //  Generate pagination buttons

  // Google Map component with clustering
  const MapComponent = ({ listLocations, mapIsOpen }) => {
    const mapOptions = {
      minZoom: 2, //  prevents zooming out too far
      maxZoom: 18, // optional, controls max zoom-in
      restriction: {
        latLngBounds: {
          north: 85,
          south: -85,
          west: -179.9999, //  small tweak prevents wrap -- You can use 180 in both if you want
          east: 179.9999,
        },
        strictBounds: true, //  prevents moving outside world bounds
      },
      zoomControl: true,
      streetViewControl: true,
      mapTypeControl: true,
      fullscreenControl: true,
      noWrap: true,
    };

    const [hoveredMarker, setHoveredMarker] = useState(null);
    const [clusters, setClusters] = useState([]);
    const [mapZoom, setMapZoom] = useState(12);
    const mapRef = useRef(null);
    const currentZoomRef = useRef(null);
    const hideTimeoutRef = useRef(null);
    const [currentMarkers, setCurrentMarkers] = useState(listLocations);
    const isFullscreenRef = useRef(false);

    //Initialize clusters when locations changefGoogleMap
    useEffect(() => {
      if (
        !isFullscreenRef.current &&
        listLocations &&
        listLocations.length > 0
      ) {
        setCurrentMarkers(listLocations);
        const initialZoom = mapRef.current?.getZoom() || 10;
        const initialClusters = calculateClusters(listLocations, initialZoom);
        setClusters(initialClusters);
      } else if (
        !isFullscreenRef.current &&
        listLocations &&
        listLocations.length === 0
      ) {
        setCurrentMarkers([]);
        setClusters([]);
      }
    }, [listLocations]);

    const handleMouseOver = (location) => {
      if (hideTimeoutRef.current) {
        clearTimeout(hideTimeoutRef.current);
        hideTimeoutRef.current = null;
      }
      setHoveredMarker(location);
    };

    const handleMouseOut = () => {
      hideTimeoutRef.current = setTimeout(() => {
        setHoveredMarker(null);
      }, 400);
    };

    const handleZoomChanged = () => {
      if (mapRef.current) {
        const newZoom = mapRef.current.getZoom();

        if (newZoom !== currentZoomRef.current && currentMarkers.length > 0) {
          currentZoomRef.current = newZoom;

          const newClusters = calculateClusters(currentMarkers, newZoom);
          setClusters(newClusters);
          setMapZoom(newZoom);
          console.log(
            `Zoom changed to ${newZoom}. Clustering ${currentMarkers.length} markers.`
          );
        }
      }
    };
    useEffect(() => {
      if (mapIsOpen && mapRef.current) {
        const timer = setTimeout(() => {
          if (mapRef.current) {
            window.google.maps.event.trigger(mapRef.current, "resize");
            console.log("Map resized triggered via mapIsOpen change.");

            if (listLocations.length > 0) {
              mapRef.current.panTo({
                lat: listLocations[0].lat,
                lng: listLocations[0].lng,
              });
              mapRef.current.setZoom(2);
            }
          }
        }, 50);
        return () => clearTimeout(timer);
      }
    }, [mapIsOpen, listLocations]);
    // Add fullscreen API fetch logic
    useEffect(() => {
      const handleFullscreenChange = async () => {
        const isFullscreen = !!document.fullscreenElement;
        isFullscreenRef.current = isFullscreen;

        if (isFullscreen) {
          console.log(
            "Entered fullscreen: Fetching ALL property data for big map."
          );
          try {
            const baseUrl = process.env.REACT_APP_API_BASE_URL;
            const response = await fetch(
              `${baseUrl}/api/map/properties?zoomLevel=0`
            );
            const result = await response.json();

            if (Array.isArray(result.data)) {
              const newMarkers = result.data
                .filter((item) => item.latitude && item.longitude)
                .map((item) => ({
                  lat: Number(item.latitude),
                  lng: Number(item.longitude),
                  propertyId: item.id,
                  propertyName: item.propertyName || "Unnamed Property",
                  property: item,
                }));

              setCurrentMarkers(newMarkers);

              const initialZoom = mapRef.current?.getZoom() || 2;
              const newClusters = calculateClusters(newMarkers, initialZoom);
              setClusters(newClusters);

              if (mapRef.current) {
                mapRef.current.setZoom(2);
                if (newMarkers.length > 0) {
                  mapRef.current.panTo({
                    lat: newMarkers[0].lat,
                    lng: newMarkers[0].lng,
                  });
                }
              }
            } else {
              console.warn("No valid 'data' array in fullscreen response");
            }
          } catch (err) {
            console.error("Error fetching fullscreen map data:", err);
          }
        } else {
          console.log(
            "Exited fullscreen: Restoring small map data. Triggering resize."
          );

          setCurrentMarkers(listLocations);
          const initialZoom = mapRef.current?.getZoom() || 10;
          const newClusters = calculateClusters(listLocations, initialZoom);
          setClusters(newClusters);

          if (mapRef.current) {
            setTimeout(() => {
              window.google.maps.event.trigger(mapRef.current, "resize");
              console.log("Map resize triggered after exiting fullscreen.");

              if (listLocations.length > 0) {
                mapRef.current.panTo({
                  lat: listLocations[0].lat,
                  lng: listLocations[0].lng,
                });
                mapRef.current.setZoom(2);
              } else {
                mapRef.current.panTo(defaultCenter);
                mapRef.current.setZoom(2);
              }
            }, 100);
          }
        }
      };

      document.addEventListener("fullscreenchange", handleFullscreenChange);
      document.addEventListener(
        "webkitfullscreenchange",
        handleFullscreenChange
      );
      document.addEventListener("mozfullscreenchange", handleFullscreenChange);
      document.addEventListener("msfullscreenchange", handleFullscreenChange);

      return () => {
        document.removeEventListener(
          "fullscreenchange",
          handleFullscreenChange
        );
        document.removeEventListener(
          "webkitfullscreenchange",
          handleFullscreenChange
        );
        document.removeEventListener(
          "mozfullscreenchange",
          handleFullscreenChange
        );
        document.removeEventListener(
          "msfullscreenchange",
          handleFullscreenChange
        );
      };
    }, [listLocations]);

    return (
      <GoogleMap
        mapContainerStyle={
          !!document.fullscreenElement
            ? fullScreenMapContainerStyle
            : mapContainerStyle
        }
        center={defaultCenter}
        zoom={2}
        options={mapOptions}
        onZoomChanged={handleZoomChanged}
        onLoad={(map) => {
          mapRef.current = map;
          currentZoomRef.current = map.getZoom();
          setMapZoom(map.getZoom());

          if (listLocations.length > 0) {
            map.panTo({ lat: listLocations[0].lat, lng: listLocations[0].lng });
            map.setZoom(2);
          }
        }}
      >
        {clusters.map((cluster) => (
          <Marker
            key={cluster.propertyId}
            position={{ lat: cluster.lat, lng: cluster.lng }}
            icon={
              cluster.isCluster
                ? generateClusterIcon(cluster.count)
                : customMarkerIcon
            }
            onMouseOver={() => handleMouseOver(cluster)}
            onClick={() => {
              if (cluster.isCluster && cluster.markers.length === 1) {
                handleViewDetails(
                  cluster.markers[0].propertyId,
                  cluster.markers[0].property?.propeId
                );
              } else if (!cluster.isCluster) {
                handleViewDetails(
                  cluster.propertyId,
                  cluster.property?.propeId
                );
              } else if (cluster.isCluster && mapRef.current) {
                mapRef.current.panTo({ lat: cluster.lat, lng: cluster.lng });
                mapRef.current.setZoom(mapZoom + 2);
              }
            }}
          />
        ))}

        {hoveredMarker && (
          <InfoWindow
            position={{ lat: hoveredMarker.lat, lng: hoveredMarker.lng }}
            onCloseClick={() => setHoveredMarker(null)}
            onMouseOver={() => {
              if (hideTimeoutRef.current) clearTimeout(hideTimeoutRef.current);
            }}
            onMouseOut={handleMouseOut}
          >
            <div>
              <h4 style={{ margin: "0 0 8px 0", fontSize: "14px" }}>
                {hoveredMarker.isCluster
                  ? `${hoveredMarker.count} Properties`
                  : hoveredMarker.propertyName}
              </h4>

              <div>
                {(hoveredMarker.isCluster
                  ? hoveredMarker.markers
                  : [hoveredMarker]
                ).map((marker, index) => {
                  const prop = marker.property || {};
                  const imageUrl =
                    prop.propertyImages && prop.propertyImages.length > 0
                      ? prop.propertyImages[0].imageUrl
                      : placeimg;

                  // Real dynamic price
                  const price = (() => {
                    if (prop.liveBid) {
                      return `$${Number(prop.liveBid).toLocaleString()}`;
                    }

                    const details = prop.biddingDetails;
                    if (!details) {
                      return prop.desiredPropertyValue
                        ? `$${Number(
                            prop.desiredPropertyValue
                          ).toLocaleString()}`
                        : "$N/A";
                    }

                    const { currenntAuctionAmount, bidStartingValue } = details;
                    if (currenntAuctionAmount != null)
                      return `$${Number(
                        currenntAuctionAmount
                      ).toLocaleString()}`;
                    if (bidStartingValue != null)
                      return `$${Number(bidStartingValue).toLocaleString()}`;
                    return "$N/A";
                  })();

                  return (
                    <div key={index}>
                      <div className="makerimg">
                        <img src={imageUrl} alt="property" />
                      </div>

                      <div className="propnflx">
                        {prop.propertySubType || "No Name"}
                        <div
                          style={{
                            display: "flex",
                            gap: "8px",
                            fontSize: "12px",
                            color: "#666",
                            alignItems: "center",
                          }}
                        >
                          <span
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                            }}
                          >
                            🛏 {prop.bedroomsTotal ?? "N/A"}
                          </span>
                          <span
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                            }}
                          >
                            🛁 {prop.bathroomsTotalInteger ?? "N/A"}
                          </span>
                          <span
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                            }}
                          >
                            📐{" "}
                            {prop.lotSizeArea
                              ? `${prop.lotSizeArea} sqft`
                              : "N/A"}
                          </span>
                        </div>
                      </div>

                      <div className="peoicer">
                        <h4 className="prices">
                          {(() => {
                            if (prop.liveBid) {
                              return `$${Number(
                                prop.liveBid
                              ).toLocaleString()}`;
                            }

                            const details = prop.biddingDetails;

                            if (!details) {
                              return `$${
                                prop.listPrice?.toLocaleString() || "N/A"
                              }`;
                            }

                            const { currenntAuctionAmount, bidStartingValue } =
                              details;

                            if (
                              currenntAuctionAmount !== null &&
                              currenntAuctionAmount !== undefined
                            ) {
                              return `$${Number(
                                currenntAuctionAmount
                              ).toLocaleString()}`;
                            }

                            if (
                              bidStartingValue !== null &&
                              bidStartingValue !== undefined
                            ) {
                              return `$${Number(
                                bidStartingValue
                              ).toLocaleString()}`;
                            }

                            return "$N/A";
                          })()}
                        </h4>

                        <button
                          className="VIEWMAKER"
                          onClick={() => {
                            handleViewDetails(prop.id, prop.propeId);
                            setHoveredMarker(null);
                          }}
                        >
                          View
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </InfoWindow>
        )}
      </GoogleMap>
    );
  };
  // Google Map component with clustering

  return (
    <>
      <div className="myallcs">
        <Header />
        <div className="listing-container scrolleffectnm">
          {/*Search Bar & Filters */}
          <div className="filter-btn-wrap">
            <div className="main-search-bar">
              {/* Search Input */}
              <div>
                <input
                  type="text"
                  className="search-input"
                  placeholder="City, State or Address"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>

              {/* Property Type Filter */}
              <select
                className="select-input"
                value={propertyType}
                onChange={(e) => setPropertyType(e.target.value)}
              >
                <option value="">Property Type</option>
                {propertyTypes.map((type, index) => (
                  <option key={index} value={type}>
                    {type}
                  </option>
                ))}
              </select>

              {/* Min Price Filter */}
              <select
                value={minPrice}
                onChange={(e) => setMinPrice(e.target.value)}
              >
                <option value="">No Min</option>
                {priceList.map((price, index) => (
                  <option key={index} value={price}>
                    {price}
                  </option>
                ))}
              </select>

              {/* Max Price Filter */}
              <select
                value={maxPrice}
                onChange={(e) => setMaxPrice(e.target.value)}
              >
                <option value="">No Max</option>
                {priceList.map((price, index) => (
                  <option key={index} value={price}>
                    {price}
                  </option>
                ))}
              </select>

              <button
                className="filter-btn"
                onClick={() => setShowFilter(true)}
                style={{ width: "50%" }}
              >
                More Filter
              </button>

              {/* Apply Button */}
              <button
                className="applyfilter"
                onClick={() => fetchFilteredProperties(0)}
                disabled={
                  !searchQuery && !propertyType && !minPrice && !maxPrice
                } // disable if all are empty
                style={{
                  opacity:
                    !searchQuery && !propertyType && !minPrice && !maxPrice
                      ? 0.6
                      : 1,
                  cursor:
                    !searchQuery && !propertyType && !minPrice && !maxPrice
                      ? "not-allowed"
                      : "pointer",
                }}
              >
                Apply
              </button>
            </div>

            <div className="newflx">
              <button
                onClick={handleToggleView}
                style={{
                  backgroundColor: showNearby ? "rgb(20 71 136)" : "#f0f0f0",
                  color: "#fff",
                  border: "none",
                  borderRadius: "30px",
                  padding: "8px 16px",
                  cursor: "pointer",
                  width: "43px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img src={Nearloaction} className="nerlocin" />
              </button>

              <button
                className="map-toggle-btn filtersbutton"
                onClick={() => setMapOpen(!mapOpen)}
              >
                {mapOpen ? (
                  <FaListUl size={22} />
                ) : (
                  <FaMapMarkedAlt size={22} />
                )}
              </button>
            </div>
          </div>
          {/*Filter Modal - Keep this section as is */}
          {showFilter && (
            <div className="filter-modal">
              <div className="filter-content">
                <span
                  className="close-btnbyr"
                  onClick={() => setShowFilter(false)}
                >
                  &times;
                </span>

                {/*Search Input */}
                <div className="filter-search">
                  <input type="text" placeholder="City,State or Address" />
                </div>

                {/* Grid Layout */}
                <div className="filter-grid-advanced">
                  {/* Property Type */}
                  <div className="filter-item">
                    <label>Property Type</label>
                    <select
                      value={propertyTypex}
                      onChange={(e) => setPropertyTypex(e.target.value)}
                    >
                      {propertyTypes.map((type, index) => (
                        <option key={index} value={type}>
                          {type}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Price */}
                  <div className="filter-item">
                    <label>Price</label>
                    <div className="range-inputs">
                      <select>
                        <option value="">No Min</option>
                        {priceList.map((price, index) => (
                          <option key={index} value={price}>
                            {price}
                          </option>
                        ))}
                      </select>
                      <select>
                        <option value="">No Max</option>
                        {priceList.map((price, index) => (
                          <option key={index} value={price}>
                            {price}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  {/* Farm Type */}
                  {propertyTypex === "Agriculture" && (
                    <div className="filter-item">
                      <label>Farm Type</label>
                      <select
                        value={farmType}
                        onChange={(e) => setFarmType(e.target.value)}
                      >
                        <option value="">Any</option>
                        {farmList.map((farm, index) => (
                          <option key={index} value={farm}>
                            {farm}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}

                  {/* Parking Type */}
                  {propertyTypex === "Parking" && (
                    <div className="filter-item">
                      <label>Parking Type</label>
                      <select
                        value={parkingType}
                        onChange={(e) => setParkingType(e.target.value)}
                      >
                        <option value="">Any</option>
                        {parkingList.map((p, index) => (
                          <option key={index} value={p}>
                            {p}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                  {/* Beds */}
                  {propertyTypex !== "Vacant Land" &&
                    propertyTypex !== "Multi Family" &&
                    propertyTypex !== "Parking" && (
                      <div className="filter-item">
                        <label>Beds</label>
                        <select
                          value={beds}
                          onChange={(e) => setBeds(e.target.value)}
                        >
                          {bedsList.map((b, i) => (
                            <option key={i} value={b}>
                              {b}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}

                  {/* Baths */}
                  {propertyTypex !== "Vacant Land" &&
                    propertyTypex !== "Multi Family" &&
                    propertyTypex !== "Parking" && (
                      <div className="filter-item">
                        <label>Baths</label>
                        <select
                          value={baths}
                          onChange={(e) => setBaths(e.target.value)}
                        >
                          {bathsList.map((b, i) => (
                            <option key={i} value={b}>
                              {b}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}

                  {/* Square Footage */}
                  {propertyTypex !== "Vacant Land" &&
                    propertyTypex !== "Parking" && (
                      <div className="filter-item">
                        <label>Square Footage</label>
                        <div className="range-inputs">
                          <select
                            value={minSquareFootage}
                            onChange={(e) =>
                              setMinSquareFootage(e.target.value)
                            }
                          >
                            <option value="">No Min</option>
                            {squareFootageList.map((sqft, index) => (
                              <option key={index} value={sqft}>
                                {sqft}
                              </option>
                            ))}
                          </select>
                          <select
                            value={maxSquareFootage}
                            onChange={(e) =>
                              setMaxSquareFootage(e.target.value)
                            }
                          >
                            <option value="">No Max</option>
                            {squareFootageList.map((sqft, index) => (
                              <option key={index} value={sqft}>
                                {sqft}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    )}
                  {/* Listed Since */}
                  <div className="filter-item">
                    <label>Listed Since</label>
                    <div className="date-inputs">
                      <input type="date" />
                      <input type="date" />
                    </div>
                  </div>

                  {/* Building Type */}
                  {propertyTypex !== "Vacant Land" &&
                    propertyTypex !== "Multi Family" &&
                    propertyTypex !== "Parking" && (
                      <div className="filter-item">
                        <label>Building Type</label>
                        <select
                          value={buildingType}
                          onChange={(e) => setBuildingType(e.target.value)}
                        >
                          <option value="">Any</option>
                          {buildingTypeList.map((type, i) => (
                            <option key={i} value={type}>
                              {type}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}

                  {/* Building Style */}
                  {(buildingType === "House" ||
                    buildingType === "Row/Townhouse") && (
                    <div className="filter-item">
                      <label>Building Style</label>
                      <select>
                        <option value="">Any</option>
                        {buildingStyleList.map((style, index) => (
                          <option key={index} value={style}>
                            {style}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}

                  {/* Storeys */}
                  {propertyTypex !== "Vacant Land" &&
                    propertyTypex !== "Parking" && (
                      <div className="filter-item">
                        <label>Storeys</label>
                        <div className="range-inputs">
                          <select
                            value={minStoreys}
                            onChange={(e) => setMinStoreys(e.target.value)}
                          >
                            <option value="">No Min</option>
                            {storeysList.map((storey, index) => (
                              <option key={index} value={storey}>
                                {storey}
                              </option>
                            ))}
                          </select>
                          <select
                            value={maxStoreys}
                            onChange={(e) => setMaxStoreys(e.target.value)}
                          >
                            <option value="">No Max</option>
                            {storeysList.map((storey, index) => (
                              <option key={index} value={storey}>
                                {storey}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    )}
                  {/* Ownership / Title */}
                  {propertyTypex !== "Vacant Land" &&
                    propertyTypex !== "Recreational" &&
                    propertyTypex !== "Agriculture" &&
                    propertyTypex !== "Parking" && (
                      <div className="filter-item">
                        <label>Ownership / Title</label>
                        <select
                          value={ownershipTitle}
                          onChange={(e) => setOwnershipTitle(e.target.value)}
                        >
                          <option value="">Select Ownership / Title</option>
                          <option value="Freehold">Freehold</option>
                          <option value="Leasehold">Leasehold</option>
                          <option value="Condominium">Condominium</option>
                          <option value="Timeshare">Timeshare</option>
                        </select>
                      </div>
                    )}

                  {/* Number of Units */}
                  {propertyTypex === "Multi Family" && (
                    <div className="filter-item">
                      <label>Number of Units</label>
                      <select
                        value={numberOfUnits}
                        onChange={(e) => setNumberOfUnits(e.target.value)}
                      >
                        {numberOfUnitsList.map((u, i) => (
                          <option key={i} value={u}>
                            {u}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}

                  {/* Exterior Building Size */}
                  {propertyTypex === "Multi Family" && (
                    <div className="filter-item">
                      <label>Exterior Building Size</label>
                      <select
                        value={exteriorBuildingSize}
                        onChange={(e) =>
                          setExteriorBuildingSize(e.target.value)
                        }
                      >
                        {exteriorBuildingSizeList.map((size, i) => (
                          <option key={i} value={size}>
                            {size}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}

                  {/* listed footage */}
                  {propertyTypex !== "Condo/Strata" &&
                    propertyTypex !== "Multi Family" &&
                    propertyTypex !== "Parking" && (
                      <div className="filter-item">
                        <label>Land Size</label>
                        <select
                          value={landSize}
                          onChange={(e) => setLandSize(e.target.value)}
                        >
                          {landSizeList.map((size, i) => (
                            <option key={i} value={size}>
                              {size}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}

                  {/* Zoning Type */}
                  {propertyTypex === "Vacant Land" && (
                    <div className="filter-item">
                      <label>Zoning Type</label>
                      <select
                        value={zoningType}
                        onChange={(e) => setZoningType(e.target.value)}
                      >
                        {zoningTypeList.map((zone, index) => (
                          <option key={index} value={zone}>
                            {zone}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                  {/* Maintenance Fees */}
                  <div className="filter-item">
                    <label>Maintenance Fees - Monthly</label>
                    <div className="range-inputs">
                      <select>
                        <option value="">No Min</option>
                        {maintenanceFeeMonthlyList.map((fee, index) => (
                          <option key={index} value={fee}>
                            {fee}
                          </option>
                        ))}
                      </select>

                      <select>
                        <option value="">No Max</option>
                        {maintenanceFeeMonthlyList.map((fee, index) => (
                          <option key={index} value={fee}>
                            {fee}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  {/* Property Tax */}
                  <div className="filter-item">
                    <label>Property Tax - Yearly</label>
                    <div className="range-inputs">
                      <select>
                        <option value="">No Min</option>
                        {propertyTaxYearlyList.map((tax, index) => (
                          <option key={index} value={tax}>
                            {tax}
                          </option>
                        ))}
                      </select>

                      <select>
                        <option value="">No Max</option>
                        {propertyTaxYearlyList.map((tax, index) => (
                          <option key={index} value={tax}>
                            {tax}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  {/* Years Built */}
                  <div className="filter-item">
                    <label>Years Built</label>
                    <div className="range-inputs">
                      <select>
                        <option value="">No Min</option>
                        {yearBuiltList.map((year, index) => (
                          <option key={index} value={year}>
                            {year}
                          </option>
                        ))}
                      </select>

                      <select>
                        <option value="">No Max</option>
                        {yearBuiltList.map((year, index) => (
                          <option key={index} value={year}>
                            {year}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                {/* Buttons */}
                <div className="filter-actions-advanced">
                  <button
                    className="reset-btn"
                    onClick={() => {
                      setSearchQuery("");
                      setPropertyType("");
                      setMinPrice("");
                      setMaxPrice("");
                      setBeds("");
                      setBaths("");
                      setPropertyTypex("");
                      setFarmType("");
                      setParkingType("");
                      setBuildingStyle("");
                      setNumberOfUnits("");
                      setExteriorBuildingSize("");
                      setOwnershipTitle("");
                      setZoningType("");
                      setLandSize("");
                      setMinSquareFootage("");
                      setMaxSquareFootage("");
                      setBuildingType("");
                      setMinStoreys("");
                      setMaxStoreys("");
                      fetchFilteredProperties();
                    }}
                  >
                    <img src={resetimg} alt="" /> Reset Filter
                  </button>
                  <button
                    className="apply-btn"
                    onClick={() => {
                      const applied = {
                        propertyTypex,
                        farmType,
                        parkingType,
                        beds,
                        baths,
                        minSquareFootage,
                        maxSquareFootage,
                        buildingType,
                        minStoreys,
                        maxStoreys,
                        ownershipTitle,
                        numberOfUnits,
                        exteriorBuildingSize,
                        landSize,
                        zoningType,
                      };
                      setAppliedFilters(applied);
                      fetchFilteredProperties();
                      setShowFilter(false);
                    }}
                  >
                    Apply Filter
                  </button>
                </div>
              </div>
            </div>
          )}

          <div className="showfilters">
            {Object.keys(appliedFilters).length > 0 && (
              <div className="applied-filters">
                <h4>
                  Applied <br></br>Filters:
                </h4>
                <ul>
                  {Object.entries(appliedFilters)
                    .filter(([key, value]) => value !== "")
                    .map(([key, value]) => (
                      <li key={key}>
                        <strong>{key}:</strong> <br></br>
                        {value}
                      </li>
                    ))}
                </ul>
                <span
                  className="close-btnbyrs"
                  onClick={() => window.location.reload()}
                >
                  &times;
                </span>
              </div>
            )}
          </div>

          <div className="contents">
            {/*Property List */}
            <div
              className={`auctions-list ${
                mapOpen ? "with-map-grid" : "full-grid"
              }`}
              style={{ width: mapOpen ? "73%" : "100%" }}
            >
              {loading ? (
                <Loader />
              ) : properties.length > 0 ? (
                properties.map((prop) => (
                  <div
                    key={prop.id}
                    className={`auctions-card ${
                      mapOpen ? "with-map" : "full-width"
                    }`}
                  >
                    {/* Property card content remains the same */}
                    <div className="auctions-image">
                      <img
                        src={
                          prop.propertyImages && prop.propertyImages.length > 0
                            ? prop.propertyImages[0].imageUrl
                            : placeimg
                        }
                        alt="property"
                      />
                    </div>

                    <div className="auctions-info">
                      <div className="auctions-details">
                        {prop.propertyType && (
                          <h1 className="listed-by">{prop.propertyType}</h1>
                        )}

                        {(prop.listingId || prop.propeId) && (
                          <h3 className="mls">
                            <strong>MLS No:</strong>{" "}
                            {prop.listingId || prop.propeId}
                          </h3>
                        )}

                        {prop.user?.name && (
                          <p className="listed-by">
                            Listed by <span>{prop.user?.name}</span>
                          </p>
                        )}
                        <h3 className="address">
                          {prop.unparsedAddress || "No Address"}
                          {prop.city && `, ${prop.city}`}
                        </h3>
                        <div className="property-specs">
                          {prop.bedroomsTotal && (
                            <span className="spec">
                              🛏{prop.bedroomsTotal}bed
                            </span>
                          )}

                          {prop.bathroomsTotalInteger && (
                            <span className="spec">
                              🛁{prop.bathroomsTotalInteger}bath
                            </span>
                          )}

                          {prop.lotSizeArea && (
                            <span className="spec">
                              📐{prop.lotSizeArea}ft²
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="bgfix">
                      <div className="CURENTS">
                        <div className="price-section">
                          {/* <p className="price-label">Current Valuation</p> */}
                        </div>
                        <h4 className="prices">
                          {(() => {
                            if (prop.liveBid) {
                              return `$${Number(
                                prop.liveBid
                              ).toLocaleString()}`;
                            }

                            const details = prop.biddingDetails;

                            if (!details) {
                              return `$${
                                prop.listPrice?.toLocaleString() || "N/A"
                              }`;
                            }

                            const { currenntAuctionAmount, bidStartingValue } =
                              details;

                            if (
                              currenntAuctionAmount !== null &&
                              currenntAuctionAmount !== undefined
                            ) {
                              return `$${Number(
                                currenntAuctionAmount
                              ).toLocaleString()}`;
                            }

                            if (
                              bidStartingValue !== null &&
                              bidStartingValue !== undefined
                            ) {
                              return `$${Number(
                                bidStartingValue
                              ).toLocaleString()}`;
                            }

                            return "$N/A";
                          })()}
                        </h4>
                      </div>
                      <div className="timebtn">
                        <Countdown
                          start={prop.biddingDetails?.bidingStartDateTime}
                          end={prop.biddingDetails?.bidingEndDateTime}
                        />

                        <button
                          className="view-btn"
                          onClick={() => {
                            handleViewDetails(prop.id, prop.propeId);
                          }}
                        >
                          View Details
                        </button>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <p style={{ textAlign: "center" }}>
                  <img src={Noprop} />
                </p>
              )}
            </div>

            {/*Map View*/}
            {mapOpen && (
              <div className="map-box">
                <LoadScriptNext
                  googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
                >
                  <MapComponent
                    listLocations={pagedMapLocations}
                    mapIsOpen={mapOpen}
                  />
                </LoadScriptNext>
              </div>
            )}
          </div>

          <div>
            {/* Pagination */}
            {totalPages > 1 && (
              <div className="pagination">{renderPaginationButtons()}</div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Buyers;
